(() => {
  const KEY = 'shopify-wishlist';
  const read = () => { try { return [...new Set((localStorage.getItem(KEY) || '').split(',').filter(Boolean))]; } catch { return []; } };
  const write = handles => {
    const wishlist = [...new Set(handles)];
    try { if (wishlist.length) localStorage.setItem(KEY, wishlist.join(',')); else localStorage.removeItem(KEY); } catch {}
    document.dispatchEvent(new CustomEvent('shopify-wishlist:updated', { detail: { wishlist } }));
  };
  // Preserve hearts saved in the original wall designer, then retire its separate list.
  try {
    const legacy = JSON.parse(localStorage.getItem('5070-art-wall-favorites') || '[]');
    if (Array.isArray(legacy) && legacy.length) write([...read(), ...legacy]);
    localStorage.removeItem('5070-art-wall-favorites');
  } catch {}

  function sync() {
    const favorites = new Set(read());
    document.querySelectorAll('[button-wishlist]').forEach(button => {
      const active = favorites.has(button.dataset.productHandle);
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    document.querySelectorAll('[data-wishlist-wall-link]').forEach(link => { link.hidden = !favorites.size; });
    const wall = document.querySelector('fifty-art-wall');
    if (wall?.ready) { wall.favorites = favorites; wall.renderCatalog(); }
  }

  // Capture once, so repeated catalog renders cannot attach duplicate heart toggles.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-aw-favorite], [button-wishlist]');
    if (!button) return;
    const handle = button.dataset.awFavorite || button.dataset.productHandle;
    if (!handle) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const favorites = new Set(read());
    favorites.has(handle) ? favorites.delete(handle) : favorites.add(handle);
    write([...favorites]);
  }, true);
  document.addEventListener('shopify-wishlist:updated', sync);
  window.addEventListener('storage', event => {
    if (event.key === KEY || event.key === null) {
      document.dispatchEvent(new CustomEvent('shopify-wishlist:updated', { detail: { wishlist: read() } }));
    }
  });

  function setupWall(wall) {
    if (!wall.ready || wall.extrasReady) return;
    wall.extrasReady = true;
            const dimensions = wall.dimensions.bind(wall);
    wall.dimensions = item => {
      const size = dimensions(item);
      const image = wall.image(item);
      if (!image?.width || !image?.height || size[0] === size[1]) return size;
      const ratio = image.width / image.height;
      return (ratio > 1.05 && size[0] < size[1]) || (ratio < 0.95 && size[0] > size[1]) ? [size[1], size[0]] : size;
    };
// The printable wall area runs from ceiling to floor and represents 280 cm.
    const printArea = wall.querySelector('.aw-prints');
    wall.wallScale = () => printArea.getBoundingClientRect().height / 280;
    const positionRemove = wall.renderWallRemove.bind(wall);
    wall.renderWallRemove = () => {
      positionRemove();
      const item = wall.items.find(item => item.key === wall.selected);
      const button = printArea.querySelector('[data-aw-remove-key]');
      const width = printArea.getBoundingClientRect().width;
      if (item && button && width) button.style.left = (item.x + wall.geometry(item).outerW * wall.wallScale() / width * 100) + '%';
    };
    const renderWall = wall.renderWall.bind(wall);
    wall.renderWall = () => {
      renderWall();
      const scale = wall.wallScale();
      if (!scale) return;
      printArea.querySelectorAll('[data-aw-item]').forEach(element => {
        const item = wall.items.find(item => item.key === element.dataset.awItem);
        if (item) element.style.width = (wall.geometry(item).outerW * scale) + 'px';
      });
      wall.renderWallRemove();
    };
    wall.scaleObserver = new ResizeObserver(() => wall.renderWall());
    wall.scaleObserver.observe(printArea);
    wall.renderWall();
sync();
    const dialog = wall.shareDialog;
    if (dialog) {
      dialog.hidden = !dialog.open;
      const share = wall.share.bind(wall);
      wall.share = () => { dialog.hidden = false; share(); };
      dialog.addEventListener('close', () => { dialog.hidden = true; });
    }
    const rooms = JSON.parse(wall.querySelector('[data-aw-rooms]')?.textContent || '[]');
    if (rooms.length) {
      const chooser = document.createElement('div');
      chooser.className = 'aw-rooms';
            chooser.innerHTML = '<button type="button" class="aw-room-toggle" aria-expanded="false">בחירת קיר <span aria-hidden="true">⌄</span></button><div class="aw-room-panel" hidden><div class="aw-room-heading"><strong>איזה קיר מתאים לכם?</strong><button type="button" class="aw-room-close" aria-label="סגירת בחירת הקיר">×</button></div><div class="aw-room-grid"></div><p>גובה הקיר 2.8 מטר · ההדפסים מוצגים בקנה מידה אמיתי</p></div>';
      const grid = chooser.querySelector('.aw-room-grid');
      rooms.forEach(room => {
        const button = document.createElement('button'); button.type = 'button'; button.dataset.awRoom = room.id;
        const image = document.createElement('img'); image.src = room.src; image.alt = ''; image.loading = 'lazy'; image.width = 150; image.height = 100;
        const label = document.createElement('span'); label.textContent = room.label;
        button.append(image, label); grid.append(button);
      });
      wall.querySelector('.aw-stage').append(chooser);
      const panel = chooser.querySelector('.aw-room-panel'), toggle = chooser.querySelector('.aw-room-toggle');
      const close = () => { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); };
      const choose = id => {
        const room = rooms.find(room => room.id === id) || rooms[0];
        wall.roomId = room.id;
        wall.querySelector('.aw-wall').style.setProperty('--wall-photo', `url("${room.src}")`);
        grid.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.awRoom === room.id)));
        try { localStorage.setItem('5070-art-wall-room', room.id); } catch {}
      };
      toggle.addEventListener('click', () => { panel.hidden = !panel.hidden; toggle.setAttribute('aria-expanded', String(!panel.hidden)); });
      chooser.querySelector('.aw-room-close').addEventListener('click', close);
      grid.addEventListener('click', event => { const button = event.target.closest('[data-aw-room]'); if (button) { choose(button.dataset.awRoom); close(); toggle.focus(); } });
      document.addEventListener('click', event => { if (!chooser.contains(event.target)) close(); });
      chooser.addEventListener('keydown', event => { if (event.key === 'Escape') { close(); toggle.focus(); } });
      let saved; try { saved = localStorage.getItem('5070-art-wall-room'); } catch {}
      choose(new URL(location.href).searchParams.get('room') || saved);
      const shareUrl = wall.shareUrl.bind(wall);
      wall.shareUrl = () => { const url = new URL(shareUrl()); url.searchParams.delete('wishlist'); url.searchParams.set('room', wall.roomId); return url.href; };
    }

    if (new URL(location.href).searchParams.get('wishlist') === '1') {
      // Wait for the full catalog before resolving saved handles, including later pages.
      const importFavorites = () => {
        if (wall.next || wall.loading) return;
        observer.disconnect();
        const products = read().map(handle => wall.products.find(product => product.handle === handle)).filter(product => product?.images.length && product.variants.length);
        if (!products.length) { wall.status('אין כרגע הדפסים במועדפים. סמנו לב ליד ההדפסים שאהבתם.'); return; }
        wall.items = products.map(product => ({ key: crypto.randomUUID(), product, variant: (product.variants.find(variant => variant.available) || product.variants[0]).id, frame: null, mat: false, x: 0, y: 0 }));
        wall.pending = []; wall.selected = null;
        // Pack rows using actual print dimensions; no resizing of the selected prints.
        let x = 10, y = 9, rowHeight = 0;
                const ratio = wall.querySelector('.aw-prints').getBoundingClientRect();
        wall.items.forEach(item => {
                    const size = wall.geometry(item), width = size.outerW * wall.wallScale() / ratio.width * 100, height = size.outerH / 280 * 100;
          if (x + width > 94 && x > 10) { x = 10; y += rowHeight + 5; rowHeight = 0; }
          item.x = x; item.y = y;
          x += width + 4; rowHeight = Math.max(rowHeight, height);
        });
        wall.renderWall(); wall.renderEditor(); wall.update();
        wall.status(`${products.length} הדפסים מהמועדפים נוספו לקיר. אפשר לגרור ולסדר אותם.`);
        const url = new URL(location.href); url.searchParams.delete('wishlist'); url.hash = ''; history.replaceState(null, '', url);
      };
      const observer = new MutationObserver(importFavorites);
      observer.observe(wall.querySelector('.aw-catalog'), { childList: true });
      // more() clears its loading flag after rendering, so run after its microtask.
      const more = wall.more.bind(wall);
      wall.more = async () => { await more(); importFavorites(); };
      importFavorites();
    }
  }
  const start = () => {
    sync();
    const wall = document.querySelector('fifty-art-wall');
    if (wall) customElements.whenDefined('fifty-art-wall').then(() => setupWall(wall));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
